import NiceModal, { type NiceModalHandler, useModal } from '@ebay/nice-modal-react';
import React from 'react';

export const createModal = <A extends {}>(
  f: React.ComponentType<A & { modal: NiceModalHandler<Record<string, unknown>> }>,
) => {
  return NiceModal.create<A>((props) => {
    const modal = useModal();
    return React.createElement(f, { ...props, modal });
  });
};

type NiceModalArgs<T> = T extends keyof JSX.IntrinsicElements | React.JSXElementConstructor<any>
  ? Omit<React.ComponentProps<T>, 'id'>
  : Record<string, unknown>;

export const showModal = <_T, C>(modal: React.FC<C>, args?: NiceModalArgs<React.FC<C>>) => {
  void NiceModal.show(modal, args);
};
